import { toast } from "react-toastify"

import { FRONT_GENERAL_CONFIG } from "../config/general.config"

export class ToastrHelper {
    private static suppressErrorsUntil = 0

    /**
     * Drop error toasts for the next `durationMs`. Use when an action is
     * intentionally blocked client-side and already explained by another toast,
     * so the caller's generic failure toast doesn't stack on top of it.
     */
    static suppressErrors(durationMs: number) {
        ToastrHelper.suppressErrorsUntil = Date.now() + durationMs
    }

    /**
     * Show success message
     */
    static success(
        msg: string,
        autoClose = FRONT_GENERAL_CONFIG.defaultToastrTimeout,
        withHtml = true,
    ) {
        toast(
            withHtml ? (
                <div
                    className="custom-toastr"
                    dangerouslySetInnerHTML={{ __html: msg }}
                />
            ) : (
                msg
            ),
            {
                autoClose,
                type: "success",
            },
        )
    }

    /**
     * Show warning message
     */
    static warning(
        msg: string,
        autoClose = FRONT_GENERAL_CONFIG.defaultToastrTimeout,
        withHtml = true,
        withToastDedup = false,
    ) {
        toast(
            withHtml ? (
                <div
                    className="custom-toastr"
                    dangerouslySetInnerHTML={{ __html: msg }}
                />
            ) : (
                msg
            ),
            {
                autoClose,
                type: "warning",

                ...(withToastDedup ? { toastId: msg } : {}),
            },
        )
    }

    /**
     * Show error message
     */
    static error(
        msg: string,
        autoClose = FRONT_GENERAL_CONFIG.defaultToastrTimeout,
        withHtml = true,
    ) {
        if (Date.now() < ToastrHelper.suppressErrorsUntil) {
            return
        }

        toast(
            withHtml ? (
                <div
                    className="custom-toastr"
                    dangerouslySetInnerHTML={{ __html: msg }}
                />
            ) : (
                msg
            ),
            {
                autoClose,
                type: "error",
            },
        )
    }
}
